import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PrepareActions, UploadActions } from '@app/client/uploader/store/actions';
import { DialogRef } from '@ngneat/dialog';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import * as fromUploader from '@app/client/uploader/store/reducers';

@Component({
  selector: 'app-modal-password-required',
  templateUrl: './modal-password-required.component.html',
  styleUrls: ['./modal-password-required.component.scss']
})
export class ModalPasswordRequiredComponent implements OnInit {

  @Output() onCloseModalPasswordRequired: EventEmitter<any> = new EventEmitter<any>();

  transferPassword$: Observable<string>;

  passwordForm: FormGroup;
  subscriptions: Subscription[] = [];
  hidePassword = true;
  submitted = false;

  constructor(private readonly fb: FormBuilder, private store$: Store<fromUploader.State>, public ref: DialogRef) {
    this.transferPassword$ = this.store$.pipe(select(fromUploader.getTransferPassword));
  }

  ngOnInit() {
    this.buildPasswordForm();
  }

  buildPasswordForm(): void {
    this.passwordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(4)]],
    });
  }

  get f() { return this.passwordForm.controls; }

  resetComponent() {
    this.passwordForm.reset();
    this.submitted = false;
  }

  closeModal() {
    this.ref.close();
  }

  onSubmit() {
    this.submitted = true;
    if (this.passwordForm.valid) {
      this.store$.dispatch(PrepareActions.SetTransferPassword({ password: this.passwordForm.value.password }));
      this.closeModal();
    }
  }

  togglePassword() {
    this.hidePassword = !this.hidePassword;
  }
}
